module.exports = "<h2>Template Strings</h2><pre class=\"fragment\"><code class=\"lang-kotlin\">val name = \"Bobby\"\nval address = \"123 Fake St.\"\n<div class=\"fragment\">\nprintln(\"$name lives at $address\")    // Bobby lives at 123 Fake St.</div></code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-moar/06.pug
// module id = 336
// module chunks = 1